import { Pipe, PipeTransform } from '@angular/core';

export const ICONS_WITH_IMAGE = [
  'DVA',
  'EINVOICE',
  'GDSN',
  'IMGOPT',
  'PRODWIZ',
  'PROSPOT',
  'RAWMATMON',
  'LKSG',
  'CYBERLYZE',
  'CYBERVAULT',
];
const ICONS_ASSETS_PATH = 'assets/images/catalog/colored-icons/';

@Pipe({
  name: 'serviceIconPath',
  standalone: true,
})
export class ServiceIconPathPipe implements PipeTransform {
  transform(serviceKey: string): string {
    if (ICONS_WITH_IMAGE.includes(serviceKey)) {
      return `${ICONS_ASSETS_PATH}${serviceKey}.svg`;
    }

    return `${ICONS_ASSETS_PATH}default.svg`;
  }
}
